import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, map, Observable, throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { ISendTicketResponse, ISupportRequestPayload } from "./model";

@Injectable({
  providedIn: "root",
})
export class ContactUsService {
  private readonly uploadUrl = `${environment.baseApiUrl}/support/file-upload`;
  private readonly submitUrl = `${environment.baseApiUrl}/support/info`;

  constructor(private readonly http: HttpClient) {}

  uploadFile(storeId: string, file: File): Observable<string> {
    const formData = new FormData();
    formData.append("storeId", storeId);
    formData.append("file", file);

    return this.http.post<{ fileId: string }>(this.uploadUrl, formData).pipe(
      map((response) => response.fileId),
      catchError((error) => {
        return throwError(() => error);
      }),
    );
  }

  sendTicket(payload: ISupportRequestPayload): Observable<ISendTicketResponse> {
    return this.http.post<ISendTicketResponse>(this.submitUrl, payload).pipe(
      catchError((error) => {
        return throwError(() => error);
      }),
    );
  }
}
